import { render, staticRenderFns } from "./sex.vue?vue&type=template&id=9ef7f07e&scoped=true"
import script from "./sex.vue?vue&type=script&lang=ts"
export * from "./sex.vue?vue&type=script&lang=ts"
import style0 from "./sex.vue?vue&type=style&index=0&id=9ef7f07e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef7f07e",
  null
  
)

export default component.exports